import { Suspense, useEffect } from "react";
// react router
import { Outlet } from "react-router";
// components
import SideDrawer from "../drawer/SideDrawer";
import ThreeDotsLoader from "../loader/ThreeDotsLoader";
// mui
import {
  Container,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  AppBar,
} from "@mui/material";
import { getMeta } from "../../redux/features/meta/metaSlice";
import { useDispatch } from "react-redux";
import { CgMenuRight } from "react-icons/cg";
const drawerWidth = 280;
const MainLayout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMeta() as any);
  }, [dispatch]);
  return (
    <Stack direction="row">
      <SideDrawer />
      <Stack
        sx={[
          (theme) => ({
            flex: "1",
            maxHeigth: "100vh",
            height: "100vh",
            overflow: "auto",
            pt: 10,
          }),
          (theme) =>
            theme.applyStyles("dark", {
              backgroundColor: "#141414",
            }),
          (theme) =>
            theme.applyStyles("light", {
              backgroundColor: "#f9f9f9",
            }),
        ]}
      >
        <Container
          sx={
            {
              // height: "calc(100vh - 100px)",
              // minHeight: "calc(100vh - 100px)",
            }
          }
        >
          <Stack
            sx={[
              (theme) => ({
                // borderRadius: 2,
                // height: "calc(100vh - 100px)",
                // minHeight: "calc(100vh - 100px)",
                // py: 4,
              }),
              (theme) =>
                theme.applyStyles("dark", {
                  // backgroundColor: "#101010",
                }),
              (theme) =>
                theme.applyStyles("light", {
                  // backgroundColor: "#fff",
                }),
            ]}
          >
            <Suspense fallback={<ThreeDotsLoader />}>
              <Outlet />
            </Suspense>
          </Stack>
        </Container>
      </Stack>
    </Stack>
  );
};

export default MainLayout;
